import shopifyGenericDefaults from '../shopify-generic/config.js';

const isCategoryPage = window.Convermax.Shopify?.getPageType() === 'collection';
const isVendorPage = window.Convermax.Shopify?.getPageType() === 'vendors';

window.Convermax.isCategoryPage = isCategoryPage || isVendorPage;

const hasMultipleVariants = () => {
  const variantSelects = window.document.querySelector('product-info variant-selects');
  const optionControls = variantSelects?.querySelectorAll('fieldset, select') ?? [];

  return [...optionControls].some((control) =>
    control.matches('select') ? control.options.length > 1 : control.querySelectorAll('input').length > 1,
  );
};

const updateVariantFitmentWidgets = () => {
  const productId = window.Convermax.Shopify.getProductId();
  const variantId = window.Convermax.Shopify.getVariantId();
  if (productId && variantId) {
    window.Convermax.updateVerifyFitmentWidget(productId, variantId);
    window.Convermax.updateFitmentTableWidget(productId, variantId);
  }
};

const InitFunc = () => {
  shopifyGenericDefaults.InitFunc?.();

  if (hasMultipleVariants()) {
    const variantInput = window.document.querySelector('product-info product-form .product-variant-id');
    variantInput?.addEventListener('change', () => {
      setTimeout(updateVariantFitmentWidgets, 300);
    });
  }
};

window.Convermax.quickAdd = async (e, item) => {
  // adapted copy-paste from theme quick-add.js and global.js

  e.preventDefault();

  const button = e.currentTarget;
  if (!item?.url || button.disabled) {
    return;
  }

  button.disabled = true;
  button.setAttribute('aria-disabled', 'true');

  try {
    let modal = document.getElementById('ConvermaxQuickAdd');

    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'ConvermaxQuickAdd';
      modal.className = 'popup-modal quick-add-modal popup-modal--small popup-modal--side hidden-during-load';
      modal.innerHTML = `
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Choose product options"
          class="popup-modal__content quick-add-modal__content custom-scrollbar global-settings-popup"
          tabindex="-1"
        >
          <button
            type="button"
            class="quick-add-modal__toggle tap-target button-control"
            aria-label="Close"
            data-convermax-quick-add-close
          >
            ×
          </button>
          <div class="quick-add-modal__content-info custom-scrollbar"></div>
        </div>
      `;

      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('[data-convermax-quick-add-close]')) {
          modal.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
          modal.querySelector('.quick-add-modal__content-info').replaceChildren();
          modal.opener?.focus();
        }
      });

      document.body.append(modal);
    }

    const response = await fetch(item.url);
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const productInfo = page.querySelector('product-info');

    if (!productInfo) {
      throw new Error(`Quick-add product-info not found: ${item.url}`);
    }

    productInfo.querySelectorAll('.quick-add-hidden').forEach((element) => element.remove());

    const content = modal.querySelector('.quick-add-modal__content-info');
    content.replaceChildren(productInfo);

    // Match the existing quick-add behavior for scripts inside product-info.
    content.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');

      [...oldScript.attributes].forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });

      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });

    // eslint-disable-next-line no-restricted-properties
    window.Shopify?.PaymentButton?.init();
    window.ProductModel?.loadShopifyXR?.();

    modal.opener = button;
    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    modal.querySelector('[role="dialog"]').focus();
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-disabled');
  }
};

function responseHandler(response) {
  if (isCategoryPage || isVendorPage) {
    const { selection, query, sort, pageSize, pageNumber } = window.Convermax.getSearchRequest();
    const isVehicleSelected = window.Convermax.isVehicleSelected();

    const collectionProductsCount = window.document.querySelectorAll(
      'body.collection-template #product-grid .grid__item',
    )?.length;
    const isCollectionEmpty = window.document.querySelector(
      'body.collection-template #product-grid.collection.collection--empty',
    );

    const shouldHideDefaultResults =
      isCollectionEmpty ||
      isVehicleSelected ||
      selection.length > 0 ||
      query.length > 0 ||
      pageNumber > 0 ||
      pageSize !== 36 ||
      response.Items?.length !== collectionProductsCount ||
      sort !== 'relevance' ||
      response.Messages.includes('UniversalFitResults') ||
      window.document.querySelector('.cmTemplate_timeout') ||
      window.document.querySelector('.cmTemplate_networkError');

    window.document.body.classList.toggle('cm_hideDefaultResults', shouldHideDefaultResults);
  }

  return response;
}

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  InitFunc,
  responseHandler,
  sortFields: [
    'relevance',
    'title',
    'title:desc',
    'collection_sort',
    'order_count:desc',
    'price',
    'price:desc',
    'published_at',
    'published_at:desc',
  ],
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    pageSize: 36,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['HeaderVehicleWidget', 'CategoryPage'].includes(w.name),
    ),
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        lastChildOf: '.header-wrapper',
        class: 'cm_vehicle-widget__header_container page-width',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 800,
      initCollapsed: true,
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        insertBefore: '#product-grid',
        class: 'cm_main-content',
      },
      visibleIf: () => isCategoryPage || isVendorPage,
      template: 'MainContent',
    },
    {
      name: 'CategoryFacetPanelContainer',
      type: 'SearchPage',
      location: { replace: '#main-collection-filters' },
      visibleIf: () => isCategoryPage || isVendorPage,
      template: 'FacetPanelContainer',
    },
    {
      name: 'CategoryPagination',
      type: 'SearchPage',
      location: { replace: '.pagination-wrapper' },
      visibleIf: () => isCategoryPage || isVendorPage,
      template: 'CategoryPagination',
    },
  ],
};
